import { TableSkeleton } from './Skeleton';

interface FeedbackProps {
  title: string;
  message: string;
  action?: { label: string; onClick: () => void };
}

export const EmptyState = ({ title, message, action }: FeedbackProps) => (
  <div className="feedback-card">
    <span className="feedback-icon" aria-hidden="true">◎</span>
    <h3>{title}</h3>
    <p>{message}</p>
    {action ? <button className="button button-secondary" onClick={action.onClick}>{action.label}</button> : null}
  </div>
);

export const ErrorState = ({ title, message, action }: FeedbackProps) => (
  <div className="feedback-card feedback-error" role="alert">
    <span className="feedback-icon" aria-hidden="true">!</span>
    <h3>{title}</h3>
    <p>{message}</p>
    {action ? <button className="button button-secondary" onClick={action.onClick}>{action.label}</button> : null}
  </div>
);

interface LoadingStateProps {
  rows?: number;
  columns?: number;
  label?: string;
}

export const LoadingState = ({ rows = 8, columns = 5, label = 'Loading data' }: LoadingStateProps) => (
  <TableSkeleton rows={rows} columns={columns} label={label} />
);
